import {createSlice} from '@reduxjs/toolkit';

import type {DefaultRootState} from 'react-redux';

const initialState = {isHidingDeletedComments: false};

export const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    toggleIsHidingDeletedComments: (state) => {
      state.isHidingDeletedComments = !state.isHidingDeletedComments;
    },
  },
});

export const selectIsHidingDeletedComments = (state: DefaultRootState) =>
  state.comments.isHidingDeletedComments;

export const {toggleIsHidingDeletedComments} = commentsSlice.actions;
